import { InjectionToken } from '@angular/core';
import { AuthProvider } from '../models';

export const AUTH_PROVIDER = new InjectionToken<AuthProvider>('RBR_AUTH_PROVIDER');
